import { render, staticRenderFns } from "./PaymentConditionPill.vue?vue&type=template&id=52a2d7bd&scoped=true"
import script from "./PaymentConditionPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentConditionPill.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PaymentConditionPill.vue?vue&type=style&index=0&id=52a2d7bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a2d7bd",
  null
  
)

export default component.exports